module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-drawer', {
    staticClass: "product-select-drawer",
    attrs: {
      "title": "产品选择",
      "visible": _vm.visible,
      "size": "50%",
      "before-close": _vm.handleClose,
      "wrapperClosable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "drawer-container"
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('product-select-host', {
    attrs: {
      "placeholder": "请输入产品名称"
    },
    on: {
      "search": _vm.handleSearch
    },
    scopedSlots: _vm._u([{
      key: "search-button",
      fn: function(ref) {
        var performSearch = ref.performSearch;

        return [_c('el-button', {
          directives: [{
            name: "perm",
            rawName: "v-perm",
            value: ('addProduct'),
            expression: "'addProduct'"
          }],
          attrs: {
            "type": "primary"
          },
          on: {
            "click": performSearch
          }
        }, [_vm._v("\n              搜索\n            ")])]
      }
    }]),
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [(_vm.showReturnButton) ? _c('el-button', {
    staticClass: "return-btn",
    attrs: {
      "type": "text",
      "icon": "el-icon-refresh-left"
    },
    on: {
      "click": _vm.handleReturn
    }
  }, [_vm._v("\n            返回\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedProducts.length === 0,
      "icon": "el-icon-upload"
    },
    on: {
      "click": _vm.uploadSelectedProducts
    }
  }, [_vm._v("\n            上传订单(" + _vm._s(_vm.selectedProducts.length) + ")\n          ")]), _vm._v(" "), _c('el-button', {
    staticClass: "selected-btn",
    class: {
      'has-selected': _vm.selectedProducts.length > 0
    },
    attrs: {
      "icon": "el-icon-shopping-cart"
    },
    on: {
      "click": function($event) {
        _vm.showSelectedDrawer = true
      }
    }
  }, [_vm._v("\n            查看已选\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productLoading),
      expression: "productLoading"
    }],
    ref: "productTable",
    staticClass: "custom-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.productLists,
      "element-loading-text": "加载中...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.7)",
      "row-key": _vm.getRowKey,
      "height": "calc(100%)"
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "select": _vm.handleRowSelect,
      "select-all": _vm.handleSelectAll
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "48",
      "align": "center",
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "min-width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticClass: "product-name"
        }, [_vm._v(_vm._s(row.productName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品图片",
      "width": "110",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-image', {
          staticStyle: {
            "width": "80px",
            "height": "80px",
            "border-radius": "4px"
          },
          attrs: {
            "src": row.picture,
            "fit": "cover",
            "preview-src-list": [row.picture]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productClassify.productClassifyName",
      "label": "分类",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-tag', {
          attrs: {
            "size": "small",
            "effect": "plain"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.getClassifyName(row)) + "\n              ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productClassify.productClassifyName",
      "label": "规格",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticClass: "product-name"
        }, [_vm._v(_vm._s(row.spec))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productStock.stock",
      "label": "库存",
      "width": "96",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-tag', {
          attrs: {
            "type": _vm.getStockTagType(row),
            "size": "small",
            "effect": "plain"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.getStockCount(row)) + "\n              ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticClass: "price"
        }, [_vm._v("¥" + _vm._s(_vm.getFormattedPrice(row)))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "total": _vm.totals,
      "layout": "total, prev, pager, next, jumper",
      "pager-count": 5,
      "small": "",
      "background": ""
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1), _vm._v(" "), _c('el-drawer', {
    staticClass: "selected-drawer",
    attrs: {
      "title": "已选产品",
      "visible": _vm.showSelectedDrawer,
      "size": "30%",
      "direction": "rtl",
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showSelectedDrawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "selected-drawer-content"
  }, [(_vm.selectedProducts.length > 0) ? _c('div', {
    staticClass: "selected-inner"
  }, [_c('div', {
    staticClass: "selected-header"
  }, [_c('div', {
    staticClass: "selected-count"
  }, [_c('i', {
    staticClass: "el-icon-shopping-cart"
  }), _vm._v(" "), _c('span', [_vm._v("已选 " + _vm._s(_vm.selectedProducts.length) + " 件商品")])]), _vm._v(" "), _c('el-button', {
    staticClass: "clear-all-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.clearAllSelected
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v(" 删除所有\n              ")])], 1), _vm._v(" "), _c('el-scrollbar', {
    staticClass: "selected-scrollbar"
  }, [_c('div', {
    staticClass: "selected-list"
  }, _vm._l((_vm.selectedProducts), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "selected-item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [_c('el-image', {
      staticStyle: {
        "width": "60px",
        "height": "60px"
      },
      attrs: {
        "src": item.picture,
        "fit": "cover"
      }
    }, [_c('div', {
      staticClass: "image-slot",
      attrs: {
        "slot": "error"
      },
      slot: "error"
    }, [_c('i', {
      staticClass: "el-icon-picture-outline"
    })])])], 1), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-price"
    }, [_vm._v("¥" + _vm._s(_vm.getFormattedPrice(item)))]), _vm._v(" "), _c('span', {
      staticClass: "item-stock"
    }, [_vm._v("库存: " + _vm._s(_vm.getStockCount(item)))])])]), _vm._v(" "), _c('div', {
      staticClass: "item-actions"
    }, [_c('el-button', {
      staticClass: "remove-btn",
      attrs: {
        "type": "text",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeSelected(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close"
    })])], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "selected-footer"
  }, [_c('el-button', {
    staticClass: "confirm-btn",
    attrs: {
      "type": "primary",
      "size": "medium",
      "disabled": _vm.selectedProducts.length === 0
    },
    on: {
      "click": _vm.uploadSelectedProducts
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" 确认选择 (" + _vm._s(_vm.selectedProducts.length) + ")\n              ")])], 1)], 1) : _c('div', {
    staticClass: "empty-selected"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无已选产品"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "back-btn",
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showSelectedDrawer = false
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v(" 返回选择\n            ")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-464d32da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/productSelect.vue
// module id = 1005
// module chunks = 3